// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"31a32e17","667":"da50c501"}[chunkId] + ".chunk.js";
};